import { USER_WATCH_VIDEO } from '~/graphql/mutations/teacher'

const actionTypes = {
  USER_WATCH_VIDEO: 'USER_WATCH_VIDEO',
}

const mutationTypes = {
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_SUBMITTING_ERROR: 'SET_SUBMITTING_ERROR',
}

export const state = () => ({
  error: '',
  submitting: false,
})

export const mutations = {
  [mutationTypes.SET_SUBMITTING](state, submitting) {
    state.submitting = submitting
  },
  [mutationTypes.SET_SUBMITTING_ERROR](state, error) {
    state.submitting = false
    state.error = error
  },
}

export const actions = {
  [actionTypes.USER_WATCH_VIDEO]({ commit }, watchedInput) {
    commit(mutationTypes.SET_SUBMITTING, true)
    try {
      const apolloClient = this.app.apolloProvider.defaultClient
      apolloClient.mutate({
        mutation: USER_WATCH_VIDEO,
        variables: watchedInput,
      })
      commit(mutationTypes.SET_SUBMITTING, true)
    } catch (error) {
      console.error('USER_WATCH_VIDEO', error)
      commit(mutationTypes.SET_SUBMITTING_ERROR, error)
    }
  },
}

export const getters = {
  error: (state) => state.error,
  submitting: (state) => state.submitting,
}
